export default function (arr, val) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === val) {
      return i
    }
  }

  return false
}



// WEBPACK FOOTER //
// ./src/forms/select-country/_utils/finderKeyByValue.js